import { render, staticRenderFns } from "./wash.vue?vue&type=template&id=30848851&scoped=true&"
import script from "./wash.vue?vue&type=script&lang=js&"
export * from "./wash.vue?vue&type=script&lang=js&"
import style0 from "./wash.vue?vue&type=style&index=0&id=30848851&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30848851",
  null
  
)

export default component.exports